import React from 'react';
import { Card, Button } from 'antd';
import { MujiLink } from '@souche-f2e/muji';
import styles from './app.module.less';


const textStyle = {
  marginTop: 5,
  fontSize: 12
};

function App({ app = {} }) {
  return (
    <div className={styles.appList}>
      <Card className={styles.app}>
        <div style={{ height: '150px' }}>
          <img src="https://blog.souche.com/content/images/2016/12/logo-3.png" alt="" style={{ width: 60, height: 60, float: 'left' }} />
          <div style={{ textAlign: 'left', marginLeft: 72 }}>
            <div>
              <span className={styles.appName}>{app.name}</span>
              <span className={styles.appStatus}>上线运行中</span>
            </div>
            <div className={styles.appCol}>{`code: ${app.code}`}</div>
            <div className={styles.appCol} style={{
              maxWidth: '15em',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}>{`AppKey: ${app.appKey}`}</div>
            <div className={styles.appCol}>
              APP 说明: <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{app.description}</span>
            </div>
          </div>
        </div>
        <MujiLink to={`/dashboard/app/${app.appKey}`} style={{ color: 'black' }} >
          <Button className={styles.appButton}>应用管理</Button>
        </MujiLink>
      </Card>
    </div>
  )
}

export default function ({ apps = [] }) {
  return <div style={{ margin: '30px 40px 30px 40px', width: 1200 }}>
    {apps.map(item => <App key={item.appId} app={item} />)}
  </div>
}